import http from './http';


export default class SearchService {
    getAll(index: string, culture: string) {
        return http.get(`search/${index}?culture=${culture}`);
    }

    get(index: string, take: number, skip: number, culture: string) {
        return http.get(`search/${index}?take=${take}&skip=${skip}&culture=${culture}`);
    }

    getByQuery(index: string, query: string, culture: string) {
        return http.get(`search/${index}?query=${encodeURIComponent(query)}&culture=${culture}`);
    }

    async getByQueryLimited(index: string, query: string, take: number, skip: number, culture: string) {
        return await http.get(`search/${index}?query=${encodeURIComponent(query)}&take=${take}&skip=${skip}&culture=${culture}`);
    }
}

// A singleton instance
export const searchService = new SearchService();